import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../assests/Css/menu.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../assests/Css/footer.css';
import Swal from "sweetalert2";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} style={{ ...style, display: "block", background: "black" }} onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return <div className={className} style={{ ...style, display: "block", background: "black" }} onClick={onClick} />;
}
const Footer = (props) => {

  const [footerBanner, setFooterBanner] = useState([]);
  const [socialMedia, setSocialMedia] = useState([]);
  const [footerData, setFooterData] = useState([]);
  const [footerAdvertisements, setFooterAdvertisement] = useState([]);

  // if(props.footerBanner){
  //   setFooterData(props.footerBanner);
  // }
  // if(props.socialMedia){
  //   setFooterBanner(props.socialMedia);
  // }
  // if(props.footerData){
  //   setSocialMedia(props.footerData);
  // }
  // if(props.footerAdvertisements){
  //   setFooterAdvertisement(props.footerAdvertisements);
  // }
  // useEffect(() => {
  //   axios.get("footer-management")
  //     .then(resp => {
  //       setFooterData(resp.data.footerManagement);
  //     });

  //   axios.get("footer-banner")
  //     .then(resp => {
  //       setFooterBanner(resp.data.banner[0]);
  //     });

  //   axios.get("social-media")
  //     .then(resp => {
  //       setSocialMedia(resp.data.props.socialMedia);
  //     });

  //   axios.get("footer-advertisement")
  //     .then(resp => {
  //       setFooterAdvertisement(resp.data.advertisement);
  //     });

  // }, []);

  // console.log(props.footerData);

  var settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const [error, setError] = useState();
  let [email, setEmail] = useState("");
  const handleSubscribe = () => {
    if (email) {
      axios
        .post("subscriber", { email: email })
        .then(function (resp) {
          // console.log('then er vitor');
          // console.log(resp.data);
          if (resp.data.success_message) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: resp.data.success_message,
              // showConfirmButton: false,
              // timer: 2000
            })
          }
          else {
            Swal.fire({
              position: 'center',
              icon: 'warning',
              title: 'error',
              // showConfirmButton: false,
              // timer: 2000
            })
            // setError(resp.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: err.response.data.message,
            // showConfirmButton: false,
            // timer: 2000
          })
          setError(err.response.data.message);
        });
    }
  }
  // console.log(error);
  // render() {
  return (
    <div>
      <footer className="">

        <div>

          {/* ===========================================================================================================================> */}

          {window.location.pathname === '/' && (
          props.footerBanner && (
            <div className="footer1">
              {/* <img src="/assets/images/foot-background.png" className="fishes f22 subscribe_bg" /> */}
              <img src={props.footerBanner.banner_image && (axios.defaults.baseURL.slice(0, -4) + "frontend/images/footer_banner_images/" + props.footerBanner.banner_image)} className="fishes f22 subscribe_bg" />
              {/* <img src={props.footerBanner.banner_image && (axios.defaults.baseURL.slice(0, -4) + "frontend/images/footer_banner_images/" + props.footerBanner.banner_image)} className="d-none d-md-block fish f23 subscribe_top_img" /> */}
              <div className="top-left subscribe_div_section">
                <h2 className="display-22 mb-md-4 fsub" style={{ color: "#0098b8", width: "90%" }}>
                  {props.footerBanner.title}
                </h2>
                <p className="fsub fpd subscribe_subtext">{props.footerBanner.sub_title}</p>
                <div className="newsletter f24 subscribe_email_field">
                  <div className="form-subscribe d-flex subscribe_field">
                    {/* <span className='text-danger ps-1'>{error && (error)}</span> */}
                    <input className="slider_text " type="email" name="email" placeholder="Email address" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                    <button className="btn subscribeButton" type="submit" onClick={() => {
                      handleSubscribe()
                    }}>
                      Subscribe
                    </button>
                  </div>
                  <div className="col-auto">
                    {/* <input type="hidden" name="g-recaptcha-response" id="g-recaptcha-response-62d4da719eba3" /> */}
                  </div>
                </div>
              </div>
            </div>
          )
          )}

          <section className="featured section-padding-30">
            <div className="">
              <div className="row">
                <Slider {...settings} className='p-0'>
                {props.footerAdvertisements &&
                    props.footerAdvertisements.map((footerAdvertisement, index) => {
                      return (
                        <div key={index} className="slider-gap">
                          <div className="col-12 p-0">
                            <div className="banner-left-icon d-flex align-items-center  fadeIn  animated" data-wow-delay="0.2s">
                              <div className="banner-icon">
                                <img src={footerAdvertisement.advertisement_image && (axios.defaults.baseURL.slice(0, -4) + "frontend/images/footer_advertisement_images/" + footerAdvertisement.advertisement_image)} alt="icon" />
                              </div>
                              <div className="banner-text">
                                <h3 className="icon-box-title">{footerAdvertisement.title}</h3>
                                <p>{footerAdvertisement.sub_title}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                              );
                    })}
                  {/* <div className="slider-gap">
                    <div className="col-12 p-0">
                      <div className="banner-left-icon d-flex align-items-center  fadeIn  animated" data-wow-delay="0.2s">
                        <div className="banner-icon">
                          <img src="/assets/images/footer/icon-1.png" alt="icon" />
                        </div>
                        <div className="banner-text">
                          <h3 className="icon-box-title">Best prices &amp; offers</h3>
                          <p>Orders more</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="slider-gap">
                    <div className="col-12">
                      <div className="banner-left-icon d-flex align-items-center  fadeIn  animated" data-wow-delay="0.4s">
                        <div className="banner-icon">
                          <img src="/assets/images/footer/icon-2.png" alt="icon" />
                        </div>
                        <div className="banner-text">
                          <h3 className="icon-box-title">Free delivery</h3>
                          <p>24/7 amazing services</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="slider-gap">
                    <div className="col-12">
                      <div className="banner-left-icon d-flex align-items-center  fadeIn  animated" data-wow-delay="0.6s">
                        <div className="banner-icon">
                          <img src="/assets/images/footer/icon-3.png" alt="icon" />
                        </div>
                        <div className="banner-text">
                          <h3 className="icon-box-title">Great daily deal</h3>
                          <p>When you sign up</p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="slider-gap">
                    <div className="col-12">
                      <div className="banner-left-icon d-flex align-items-center  fadeIn  animated" data-wow-delay="0.8s">
                        <div className="banner-icon">
                          <img src="/assets/images/footer/icon-4.png" alt="icon" />
                        </div>
                        <div className="banner-text">
                          <h3 className="icon-box-title">Wide assortment</h3>
                          <p>Mega Discounts</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="slider-gap">
                    <div className="col-12">
                      <div className="banner-left-icon d-flex align-items-center  fadeIn  animated" data-wow-delay="1s">
                        <div className="banner-icon">
                          <img src="/assets/images/footer/icon-5.png" alt="icon" />
                        </div>
                        <div className="banner-text">
                          <h3 className="icon-box-title">Easy returns</h3>
                          <p>Within 30 days</p>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </Slider>
                {/* row eniding below */}
              </div>
            </div>
          </section>

          <section className="section-padding footer-mid padding_top_none">
          <div className="row">
                <div className="col-md-12 col-lg-2 col-xl-2">
                  <div className="logo text-center text-lg-none">
                  {props.footerData ? (
                          <Link to="/" className="">
                          <img src={axios.defaults.baseURL.slice(0, -4) + "frontend/images/site_logos/" + props.footerData.site_logo} style={{ width: "150px" }} alt="LOGO not found" />
                          </Link>
                        ) : (
                        <Link to="/" className="">
                          <img src="/assets/images/logo/Original_logo.png" style={{ width: "150px" }} alt="LOGO not found" />
                        </Link>
                        )}
                    {/* <strong className="d-inline-block" style={{ font: 'inherit', color: 'black' }}>Some Logo Text Which Will Be Here:</strong>{" "} */}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4 col-xl-4">
                  <div className="widget-about font-md mb-md-3 mb-lg-3 mb-xl-0  wow animate__animated animate__fadeInUp text-center" data-wow-delay="0">
                    <h4 className="widget-title">Contact</h4>
                    <ul className="contact-infor">
                      <li>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0)">
                            <path
                              d="M8.00001 16.7564L7.53334 16.3564C6.89001 15.8178 1.27267 10.9664 1.27267 7.41776C1.27267 5.63356 1.98145 3.92244 3.24306 2.66082C4.50468 1.3992 6.21581 0.69043 8.00001 0.69043C9.78421 0.69043 11.4953 1.3992 12.757 2.66082C14.0186 3.92244 14.7273 5.63356 14.7273 7.41776C14.7273 10.9664 9.11001 15.8178 8.46934 16.3591L8.00001 16.7564ZM8.00001 2.1451C6.6021 2.14668 5.2619 2.70271 4.27342 3.69118C3.28495 4.67965 2.72893 6.01985 2.72734 7.41776C2.72734 9.6471 6.18334 13.2084 8.00001 14.8384C9.81667 13.2078 13.2727 9.64443 13.2727 7.41776C13.2711 6.01985 12.7151 4.67965 11.7266 3.69118C10.7381 2.70271 9.39792 2.14668 8.00001 2.1451Z"
                              fill="#3BB77E"
                            />
                            <path
                              d="M8.00001 10.0843C7.47259 10.0843 6.95702 9.92791 6.51849 9.6349C6.07996 9.34188 5.73817 8.9254 5.53633 8.43813C5.3345 7.95086 5.28169 7.41469 5.38458 6.8974C5.48748 6.38012 5.74145 5.90497 6.11439 5.53203C6.48733 5.15909 6.96249 4.90511 7.47977 4.80222C7.99705 4.69932 8.53323 4.75213 9.0205 4.95397C9.50777 5.1558 9.92425 5.49759 10.2173 5.93612C10.5103 6.37465 10.6667 6.89023 10.6667 7.41764C10.6667 8.12489 10.3857 8.80317 9.88563 9.30326C9.38553 9.80336 8.70726 10.0843 8.00001 10.0843ZM8.00001 6.08431C7.7363 6.08431 7.47852 6.16251 7.25925 6.30902C7.03999 6.45553 6.86909 6.66377 6.76817 6.9074C6.66726 7.15103 6.64085 7.41912 6.6923 7.67776C6.74374 7.93641 6.87073 8.17398 7.0572 8.36045C7.24367 8.54692 7.48125 8.67391 7.73989 8.72536C7.99853 8.77681 8.26662 8.7504 8.51026 8.64948C8.75389 8.54857 8.96213 8.37767 9.10864 8.1584C9.25515 7.93914 9.33335 7.68135 9.33335 7.41764C9.33335 7.06402 9.19287 6.72488 8.94282 6.47484C8.69277 6.22479 8.35363 6.08431 8.00001 6.08431Z"
                              fill="#3BB77E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="16" height="16" fill="white" transform="translate(0 0.750977)" />
                            </clipPath>
                          </defs>
                        </svg>

                        <strong className="d-inline-block">&nbsp;Address:</strong>{" "}
                        <span className="d-inline-block">
                          {props.footerData && (
                            props.footerData.address
                          )}
                        </span>
                      </li>
                      <li className="ln_higt">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0)">
                            <path
                              d="M14.3333 8.71789V7.76855C14.3333 6.17726 13.7012 4.65113 12.576 3.52591C11.4508 2.4007 9.92463 1.76855 8.33333 1.76855C6.74203 1.76855 5.21591 2.4007 4.09069 3.52591C2.96547 4.65113 2.33333 6.17726 2.33333 7.76855V8.71789C1.6341 9.02578 1.06186 9.56452 0.712412 10.2439C0.362959 10.9233 0.257505 11.7022 0.413703 12.45C0.5699 13.1979 0.978269 13.8694 1.57044 14.3522C2.16262 14.8349 2.90266 15.0996 3.66666 15.1019H5V8.43522H3.66666V7.76855C3.66666 6.53088 4.15833 5.34389 5.0335 4.46872C5.90867 3.59355 7.09565 3.10189 8.33333 3.10189C9.57101 3.10189 10.758 3.59355 11.6332 4.46872C12.5083 5.34389 13 6.53088 13 7.76855V8.43522H11.6667V13.7686H9V15.1019H13C13.764 15.0996 14.504 14.8349 15.0962 14.3522C15.6884 13.8694 16.0968 13.1979 16.253 12.45C16.4092 11.7022 16.3037 10.9233 15.9542 10.2439C15.6048 9.56452 15.0326 9.02578 14.3333 8.71789ZM3.66666 13.7686C3.13623 13.7686 2.62752 13.5578 2.25245 13.1828C1.87738 12.8077 1.66666 12.299 1.66666 11.7686C1.66666 11.2381 1.87738 10.7294 2.25245 10.3543C2.62752 9.97927 3.13623 9.76855 3.66666 9.76855V13.7686ZM13 13.7686V9.76855C13.5304 9.76855 14.0391 9.97927 14.4142 10.3543C14.7893 10.7294 15 11.2381 15 11.7686C15 12.299 14.7893 12.8077 14.4142 13.1828C14.0391 13.5578 13.5304 13.7686 13 13.7686Z"
                              fill="#3BB77E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="16" height="16" fill="white" transform="translate(0.333344 0.435059)" />
                            </clipPath>
                          </defs>
                        </svg>
                        <strong className="d-inline-block">&nbsp;Call Us:</strong> <span className="d-inline-block">+{props.footerData && (
                          props.footerData.office_contact
                        )}</span>
                      </li>
                      <li className="ln_higt">
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0)">
                            <path
                              d="M0.962657 5.08044C0.739429 5.14422 0.536723 5.26518 0.374598 5.43136C0.212473 5.59754 0.0965474 5.80317 0.0382929 6.0279C-0.0199617 6.25264 -0.0185264 6.48869 0.0424566 6.7127C0.10344 6.93671 0.221857 7.14091 0.385991 7.3051L2.66066 9.5771V13.9678H7.05599L9.34599 16.2544C9.46881 16.3785 9.615 16.4771 9.77611 16.5443C9.93722 16.6116 10.1101 16.6463 10.2847 16.6464C10.3994 16.6462 10.5136 16.6314 10.6247 16.6024C10.8493 16.5459 11.0551 16.4311 11.2213 16.2697C11.3874 16.1083 11.5082 15.906 11.5713 15.6831L15.994 0.648438L0.962657 5.08044ZM1.33332 6.36244L12.6853 3.01577L3.99532 11.6918V9.0251L1.33332 6.36244ZM10.2933 15.3118L7.60866 12.6344H4.94199L13.6307 3.9531L10.2933 15.3118Z"
                              fill="#3BB77E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="16" height="16" fill="white" transform="translate(0 0.634277)" />
                            </clipPath>
                          </defs>
                        </svg>
                        <strong className="d-inline-block">&nbsp;Email:</strong> <span className="d-inline-block">{props.footerData && (
                          props.footerData.email
                        )}</span>
                      </li>
                      <li className="ln_higt">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0)">
                            <path
                              d="M7.39402 16.8696H0.727356V15.5363H7.39402V16.8696ZM6.06069 12.8696H0.727356V14.203H6.06069V12.8696ZM4.72736 10.203H0.727356V11.5363H4.72736V10.203ZM8.72736 0.869629C6.60633 0.871923 4.57283 1.71551 3.07304 3.21531C1.57324 4.7151 0.72965 6.7486 0.727356 8.86963H2.06069C2.06069 7.55109 2.45168 6.26216 3.18423 5.16583C3.91677 4.0695 4.95796 3.21502 6.17613 2.71043C7.39431 2.20585 8.73475 2.07383 10.028 2.33106C11.3212 2.5883 12.5091 3.22323 13.4414 4.15558C14.3738 5.08793 15.0087 6.27582 15.2659 7.56903C15.5232 8.86223 15.3911 10.2027 14.8866 11.4209C14.382 12.639 13.5275 13.6802 12.4312 14.4128C11.3348 15.1453 10.0459 15.5363 8.72736 15.5363V16.8696C10.8491 16.8696 12.8839 16.0268 14.3842 14.5265C15.8845 13.0262 16.7274 10.9914 16.7274 8.86963C16.7274 6.7479 15.8845 4.71307 14.3842 3.21277C12.8839 1.71248 10.8491 0.869629 8.72736 0.869629V0.869629ZM8.06069 5.5363V9.14563L10.256 11.341L11.1987 10.3983L9.39402 8.59363V5.5363H8.06069Z"
                              fill="#3BB77E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="16" height="16" fill="white" transform="translate(0.727356 0.869629)" />
                            </clipPath>
                          </defs>
                        </svg>
                        <strong className="d-inline-block">&nbsp;Working Hours:</strong> <span className="d-inline-block">{props.footerData && (
                          props.footerData.working_hour
                        )}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="row"> */}
                <div className="col-6 col-md-4 col-lg-3 col-xl-3 wow animate__animated animate__fadeInUp text-center" data-wow-delay=".3s">
                  <h4 className="widget-title">Company</h4>
                  <ul className="footer-list mb-sm-5 mb-md-0">
                    <ul className="footer-list wow fadeIn animated mb-sm-5 mb-md-0">
                      <li className="ln_higt">
                        <Link to="/about-us">
                          <span>About us</span>
                        </Link>
                      </li>
                      {/* <li>
                          <a href="#">
                            <span>Affiliate</span>
                          </a>
                        </li> */}
                      {/* <li className="ln_higt">
                          <a href="#/carrer">
                            <span>Career</span>
                          </a>
                        </li> */}
                      <li className="ln_higt">
                        <Link to="/contact">
                          <span>Contact us</span>
                        </Link>
                      </li>
                    </ul>
                  </ul>
                </div>
                <div className="col-6 col-md-4 col-lg-3 col-xl-3 footer-link-widget col wow animate__animated animate__fadeInUp text-md-end" data-wow-delay=".3s">
                  <h4 className="widget-title">Information</h4>
                  <ul className="footer-list mb-sm-5 mb-md-0">
                    <ul className="footer-list wow fadeIn animated mb-sm-5 mb-md-0">

                      <li className="ln_higt">
                        <Link to="/cookie-policy">
                          <span>Cookie Policy</span>
                        </Link>
                      </li>
                      <li className="ln_higt">
                        <Link to="/terms-conditions">
                          <span>Terms &amp; Conditions</span>
                        </Link>
                      </li>
                      <li className="ln_higt">
                        <Link to="/returns-exchanges">
                          <span>Returns &amp; Exchanges</span>
                        </Link>
                      </li>
                      <li className="ln_higt">
                        <Link to="/shipping-delivery">
                          <span>Shipping &amp; Delivery</span>
                        </Link>
                      </li>
                      <li className="ln_higt">
                        <Link to="/privacy-policy">
                          <span>Privacy Policy</span>
                        </Link>
                      </li>
                    </ul>
                  </ul>
                </div>

                {/* </div> */}
              </div>
          </section>
          {/* ---------------------------------------------------------- */}

        </div>
        <div className="wow animate__animated animate__fadeInUp" data-wow-delay="0">
          <div className="row footer-bottom p-3">
            <div className="col-xl-4 d-none d-xl-block">
              <div className="hotline d-lg-inline-flex">
                <img src="/assets/images/footer/phone-call.svg" alt="hotline" height={36} />
                <p>
                  <a href={"tel:" + props.footerData.hotline_no}>{props.footerData && (
                    props.footerData.hotline_no
                  )}</a> <span>{props.footerData && (
                    props.footerData.hotline_description
                  )}</span>
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xl-4">
              <div className="text-center mt-2">{props.footerData && (
                props.footerData.copyright_description
              )}</div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4 text-end d-none d-md-block">
              <div className="mobile-social-icon">
                <h6>Follow Us</h6>

                {props.socialMedia &&
                  props.socialMedia.map((media, index) => {
                    return (
                          <a key={index} href={media.url} title={media.title} target="_blank" rel="noopener noreferrer">
                            <img src={media.social_icon && (axios.defaults.baseURL.slice(0, -4) + "frontend/images/social_icons/" + media.social_icon)} alt={media.title} />
                          </a>
                     );
                  })
                  }
                {/* <Link to="https://www.facebook.com/" title="Facebook">
                  <img src="/assets/images/footer/facebook.png" alt="Facebook" />
                </Link>
                <a href="https://www.twitter.com/" title="Twitter">
                  <img src="/assets/images/footer/twitter.png" alt="Twitter" />
                </a>
                <a href="https://www.instagram.com/" title="Instagram">
                  <img src="/assets/images/footer/instagram.png" alt="Instagram" />
                </a>
                <a href="https://www.pinterest.com/" title="Pinterest">
                  <img src="/assets/images/footer/pinterest.png" alt="Pinterest" />
                </a>
                <a href="https://www.youtube.com/" title="Youtube">
                  <img src="/assets/images/footer/youtube.png" alt="Youtube" />
                </a> */}
              </div>
              {/* <p className="font-sm">Up to 15% discount on your first subscribe</p>*/}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
export default Footer;
